// Converged into ui/Button (Design Standard v1). Kept as a thin alias so existing
// imports keep working; `as` still lets a caller render a Link with button styling.
import React from 'react';
import clsx from 'clsx';
import Button from './button';
import './ds.css';

const VARIANT = { primary: 'primary', secondary: 'secondary', ghost: 'ghost', danger: 'danger' };

export default function ActionButton({ as: Component = 'button', variant = 'secondary', size = 'md', className, ...rest }) {
  if (Component === 'button') return <Button variant={variant} size={size} className={className} {...rest} />;
  return (
    <Component
      className={clsx('ds-btn', `ds-btn--${VARIANT[variant] || 'secondary'}`, size === 'sm' && 'ds-btn--sm', className)}
      {...rest}
    />
  );
}
